import events from "./events";

const sendEvent = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ...data });
};

const trackCustomEvents = ({ events, category }, extras) => {
  const data = { ...extras, ...events[category] };
  sendEvent(data);
};

const trackEvents = (category, extras = {}) => {
  trackCustomEvents(
    {
      events: events,
      category,
    },
    extras
  );
};

export { trackEvents };
